export default __webpack_public_path__ + "static/media/fb.c48a5234.svg";